<template>
  <div></div>
</template>

<script>
import { Form } from 'vform'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      form: new Form({}),
    }
  },
  methods: {
    confirmation: function () {
      this.form.email = this.$route.query.e
      this.form.token = this.$route.query.t

      this.form.post('/auth/confirmation')
        .then( () => {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso',
            text: 'Sua email foi confirmado',
            time: 2000
          })
            .then( () => {
              window.location.href = '/painel'
            })
        })
        .catch ( err => {
          Swal.fire({
            icon: 'error',
            title: 'Opss',
            text: 'Algo deu errado, tente novamente mais tarde',
            time: 2000
          })
          console.error('erro', err)
          this.form.password = ''
          this.form.password_confirmation = ''
        })
    }
  },
  mounted () {
    this.confirmation()
  }
}
</script>
